<template>
    <div :id="id" class="flex flex-col items-center">
        <p class="font-size-18 uppercase mb-2 theme-question-shadow">{{ $t('versus_header') }}</p>
        <div class="progress">
            <p class="font-size-16 mb-0 progress-title theme-question-shadow">{{ $t('versus_average') }}</p>
            <svg width="918" height="32" viewBox="0 0 918 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M902 1H16C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31H902C910.284 31 917 24.2843 917 16C917 7.71573 910.284 1 902 1Z"
                    fill="url(#paint0_linear)"
                    stroke="white"
                    stroke-width="2"
                />
                <path d="M159 2H152V30H159V2Z" fill="#FE1900" />
                <path d="M312 2H305V30H312V2Z" fill="#F18700" />
                <path d="M465 2H458V30H465V2Z" fill="#FEC900" />
                <path d="M618 2H611V30H618V2Z" fill="#ABB700" />
                <path d="M771 2H764V30H771V2Z" fill="#2D8D00" />
                <defs>
                    <linearGradient
                        id="paint0_linear"
                        x1="917"
                        y1="15.9998"
                        x2="1.00001"
                        y2="16.0002"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#0F9032" />
                        <stop offset="0.494792" stop-color="#FFD701" />
                        <stop offset="1" stop-color="#FD0100" />
                    </linearGradient>
                </defs>
            </svg>
            <p
                v-if="!isLogin"
                @click="
                    () => {
                        this.$emit('login')
                    }
                "
                class="font-size-16 progress-title can-hover cursor-pointer theme-question-shadow"
                style="margin-top: -0.5rem"
            >
                {{ $t('versus_login') }}
            </p>
            <p v-if="isLogin" class="font-size-16 progress-current theme-question-shadow">{{ $t('versus_you') }}</p>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'

export default {
    props: {
        id: {
            type: String,
            default: 'you-vs-the-world'
        },
        isLogin: {
            type: Boolean,
            default: true
        },
        percent: {
            default: '30'
        },
        showAnimate: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        showAnimate(val) {
            if (this.isLogin) {
                this.animation(this.percent > 0 && val)
            }
        },

        percent(val) {
            if (this.isLogin) {
                this.animation(val > 0 && this.showAnimate)
            }
        },

        isLogin(val) {
            if (val) {
                this.animation(this.percent > 0 && this.showAnimate)
            }
        }
    },

    methods: {
        animation(status = true) {
            gsap.set(`#${this.id} .progress-current`, { opacity: this.percent > 0 ? 1 : 0, left: '0%' })

            if (status) {
                setTimeout(() => {
                    gsap.to(`#${this.id} .progress-current`, {
                        duration: 1,
                        left: `${this.percent}%`,
                        ease: 'power4.out'
                    })
                }, 100)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.progress {
    position: relative;
    padding-bottom: 1.5rem;

    & > svg {
        width: 100%;
    }
    .progress-title {
        margin-bottom: -0.3rem;

        &.can-hover:hover {
            text-decoration: underline;
        }
    }
    .progress-current {
        position: absolute;
        transform: translateX(-50%);
        // left: 0;
        bottom: 0.3rem;

        &::after {
            content: '';
            position: absolute;
            transform: translateX(-50%);
            left: 50%;
            top: -0.4rem;
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;

            border-bottom: 6px solid var(--ui-color);
        }
    }
}
</style>
